import React from 'react';
import { Select, TextInput } from '@mantine/core';
import { Button } from '../../../components/Button';
import {
  DATE_FILTER_OPTIONS,
  IGNORED_FILTER_OPTIONS,
  LOG_LEVEL_LABELS,
  LOG_PLACE_OPTIONS,
  STATUS_CLASS_OPTIONS,
  type DateFilterMode,
} from '../monitoring-page.constants';
import type { UseMonitoringPage } from '../useMonitoringPage';
import classes from '../monitoring-page.module.scss';

type ErrorsFiltersProps = Pick<
  UseMonitoringPage,
  | 'errorPlaceFilter' | 'setErrorPlaceFilter'
  | 'errorLevelFilter' | 'setErrorLevelFilter'
  | 'errorTenantFilter' | 'setErrorTenantFilter'
  | 'errorTenantOptions'
  | 'errorSearch' | 'setErrorSearch'
  | 'errorDateFilterMode' | 'setErrorDateFilterMode'
  | 'errorExactDate' | 'setErrorExactDate'
  | 'errorDateFrom' | 'setErrorDateFrom'
  | 'errorDateTo' | 'setErrorDateTo'
  | 'errorStatusClassFilter' | 'setErrorStatusClassFilter'
  | 'errorIgnoredFilter' | 'setErrorIgnoredFilter'
  | 'clearErrorFilters'
>;

const LEVEL_OPTIONS = Object.entries(LOG_LEVEL_LABELS).map(([value, label]) => ({ value, label }));

export const ErrorsFilters: React.FC<ErrorsFiltersProps> = ({
  errorPlaceFilter,
  setErrorPlaceFilter,
  errorLevelFilter,
  setErrorLevelFilter,
  errorTenantFilter,
  setErrorTenantFilter,
  errorTenantOptions,
  errorSearch,
  setErrorSearch,
  errorDateFilterMode,
  setErrorDateFilterMode,
  errorExactDate,
  setErrorExactDate,
  errorDateFrom,
  setErrorDateFrom,
  errorDateTo,
  setErrorDateTo,
  errorStatusClassFilter,
  setErrorStatusClassFilter,
  errorIgnoredFilter,
  setErrorIgnoredFilter,
  clearErrorFilters,
}) => (
  <div className={classes.filtersCard}>
    <div className={classes.filtersGridKitchen}>
      <div className={classes.fieldStack}>
        <Select
          label={'מקור'}
          placeholder={'בחר מקור'}
          data={LOG_PLACE_OPTIONS}
          value={errorPlaceFilter || null}
          onChange={(value) => setErrorPlaceFilter(value ?? '')}
          clearable
          data-testid="monitoring-errors-filter-place"
        />
      </div>

      <div className={classes.fieldStack}>
        <Select
          label={'חומרה'}
          placeholder={'בחר חומרה'}
          data={LEVEL_OPTIONS}
          value={errorLevelFilter || null}
          onChange={(value) => setErrorLevelFilter(value ?? '')}
          clearable
          data-testid="monitoring-errors-filter-level"
        />
      </div>

      <div className={classes.fieldStack}>
        <Select
          label={'עסק'}
          placeholder={'בחר עסק'}
          data={errorTenantOptions}
          value={errorTenantFilter || null}
          onChange={(value) => setErrorTenantFilter(value ?? '')}
          searchable
          clearable
          data-testid="monitoring-errors-filter-tenant"
        />
      </div>

      <div className={classes.fieldStack}>
        <TextInput
          label={'חיפוש'}
          placeholder={'שגיאה, נתיב או מכשיר'}
          value={errorSearch}
          onChange={(event) => setErrorSearch(event.currentTarget.value)}
          data-testid="monitoring-errors-filter-search"
        />
      </div>

      <div className={classes.fieldStack}>
        <Select
          label={'קוד'}
          placeholder={'בחר קוד'}
          data={STATUS_CLASS_OPTIONS}
          value={errorStatusClassFilter || null}
          onChange={(value) => setErrorStatusClassFilter(value ?? '')}
          clearable
          data-testid="monitoring-errors-filter-status-class"
        />
      </div>

      <div className={classes.fieldStack}>
        <Select
          label={'שגיאות מוסתרות'}
          data={IGNORED_FILTER_OPTIONS}
          value={errorIgnoredFilter}
          onChange={(value) => setErrorIgnoredFilter((value as 'hide' | 'only' | 'all') ?? 'hide')}
          allowDeselect={false}
          data-testid="monitoring-errors-filter-ignored"
        />
      </div>

      <div className={classes.fieldStack}>
        <Select
          label={'סינון תאריך'}
          data={DATE_FILTER_OPTIONS}
          value={errorDateFilterMode}
          onChange={(value) => setErrorDateFilterMode((value as DateFilterMode) ?? 'all')}
          allowDeselect={false}
          data-testid="monitoring-errors-date-mode"
        />
        {errorDateFilterMode === 'exact' && (
          <TextInput type="date" value={errorExactDate} onChange={(event) => setErrorExactDate(event.currentTarget.value)} data-testid="monitoring-errors-date-exact" />
        )}
        {errorDateFilterMode === 'between' && (
          <div className={classes.fieldRow}>
            <TextInput type="date" value={errorDateFrom} onChange={(event) => setErrorDateFrom(event.currentTarget.value)} data-testid="monitoring-errors-date-from" />
            <TextInput type="date" value={errorDateTo} onChange={(event) => setErrorDateTo(event.currentTarget.value)} data-testid="monitoring-errors-date-to" />
          </div>
        )}
      </div>
    </div>

    <div className={classes.filtersActions}>
      <Button variant="cancel" onClick={clearErrorFilters} dataTestId="monitoring-errors-clear-filters">
        {'נקה סינונים'}
      </Button>
    </div>
  </div>
);
